import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { requestJson } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type PhoneVerificationStatus = {
  phone: string | null;
  verified: boolean;
  verifiedAt: string | null;
};

export function usePhoneVerificationStatus(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.phoneVerification.all(),
    queryFn: () => requestJson<PhoneVerificationStatus>("/api/phone-verification/status"),
    enabled: options?.enabled ?? true,
  });
}

export function useStartPhoneVerification() {
  return useMutation({
    mutationFn: (phone: string) =>
      requestJson<{ ok: boolean; phone: string; status: string }>("/api/phone-verification/start", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      }),
  });
}

export function useCheckPhoneVerification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) =>
      requestJson<{ ok: boolean; phone: string; verifiedAt: string }>(
        "/api/phone-verification/check",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code }),
        },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.phoneVerification.all() });
    },
  });
}
